import { makeStyles } from '@branchjs/neo-components';

export const useStyles = makeStyles((theme) => ({
  headerText: {
    color: theme.colors.primary.contrastWhite,
  },
  bodyText: {
    color: theme.colors.gray[200],
  },
  content: {
    height: '100%',
    backgroundColor: theme.colors.sidebar.baseColor,
    paddingBottom: '24px',
    [theme.breakpoints.down('md')]: {
      height: 'auto',
    },
  },
  header: {
    padding: '150px 64px 24px 64px',
    [theme.breakpoints.down('md')]: {
      padding: '24px 64px 24px 64px',
    },
  },
}));
